import React, { Component } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import $ from 'jquery';
import TtsApiKeys from './TtsApiKeys';
import LanguageSettings from '../projectmgmt/settings/LanguageSettings';

class TtsApiSettings extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-tts/";
      var path1 = window.origin + "/platform/cloud-tts";
      if (currentPath === path || currentPath === path1) {
        $("#tts-language-tab").addClass('active');
      } else if (currentPath.includes("/cloud-tts/api-keys") || currentPath.includes("/projectmgmt/api-keys/")) {
        $("#tts-api-keys").addClass('active');
      }
      $("#tts-language-tab,#tts-api-keys")
        .on("click", function () {
          $("#tts-language-tab,#tts-api-keys")
            .removeClass('active');
          $(this).addClass('active')
        })
    })();
  }

  render() {
    return (
      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Text-To-Speech API Settings</h1>
                  <h6 className="taglineTxt">Agent Configurations</h6>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid" >
            {/* Nav tabs */}
            <div className="border-bottom"></div>
            <div className="tab-class">
              <ul className="nav nav-tabs border-bottom navCluster">
                <Link className="nav-item" to="/cloud-tts" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="tts-language-tab">
                    Language
                  </li>
                </Link>

                <Link className="nav-item" to="/cloud-tts/api-keys" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="tts-api-keys">
                    API Keys
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route path="/cloud-tts/api-keys" component={TtsApiKeys}></Route>
          <Route path="/cloud-tts" component={LanguageSettings}></Route>
        </Switch>
      </div>

    );
  }
}
export default TtsApiSettings;


// WEBPACK FOOTER //
// ./src/ttsUi/TtsApiSettings.js